import React from "react";
import { Link } from "react-router-dom";
import FriendsAdda from "../../../images/friendsAdda.png";
import EasyFix from "../../../images/Screenshot_3.png";
import TechZone from "../../../images/Screenshot_4.png";
import Project from "../Project/Project";

const Projects = () => {
    const projects = [
        {
            img: EasyFix,
            name: "Easy Fix - MERN Stack Website",
            desc: "It's a single page application, where anyone can book a electronics service. He can see his orders and status. An Admin can change status and add new service, delete service and make another admin too.",
            tech: "Html5, Css3, Bootstrap4, React JS, Node JS, Express JS and Mongodb.",
            site: "https://easy-fix-affce.web.app/",
            client: "https://github.com/saurav-ghosh/Easy-Fix-Client",
        },
        {
            img: TechZone,
            name: "Tech Zone - MERN Stack Website",
            desc: "It's an simple e-commerce website. With this app anyone can buy any products. He can see his all orders.He can add any product or delete any product and can see the result in the home page",
            tech: "Html5, Css3, Bootstrap4, React JS, Node JS, Express JS and Mongodb.",
            site: "https://tech-zone-dd59d.web.app/",
            client: "https://github.com/saurav-ghosh/Tech-Zone-Client",
        },
        {
            img: FriendsAdda,
            name: "FriendsAdda - Chatting Application (Team Project)",
            desc: "It's a real time chatting application. User can sign in with google authentication and create a message room. Then he can chat with other person in the same room. User can also log out.",
            tech: " Html5, Css3, javascript, React JS, firebase",
            site: "https://discord-group-2c7c1.firebaseapp.com/",
            client: "https://github.com/ahadhossainaiman/friendsAdda",
        },
    ];
    return (
        <section className="ms-5">
            <h2 className="service-title mt-5 pt-5">Some of my projects</h2>
            <div className="row mt-5">
                {projects.map((project) => (
                    <Project project={project}></Project>
                ))}
            </div>
            <div className="text-center mt-5">
                <Link to="/work">
                    <button className="button">See All Projects</button>
                </Link>
            </div>
        </section>
    );
};

export default Projects;
